
export function resetFunction(component: any) {
    component.displayModal = false;
    component.showBillDetail = false;
    component.showCalculator = false;
    component.showItemDetail = false;
    component.displayNoItem = true;
    component.isExchangeOrder = false;
    component.selectedInvoiceNo = '';
    component.displayMobileNumberDialog = false;
    component.mobileNumber = '';
    component.customerName = '';
    component.displayHoldNameDialog = false;
    component.holdReceiptName = '';
    component.itemId = '';
    component.activeItem = component.items && component.items.length > 1 ? component.items[1] : null;
    component.autoCompletedselectedProduct = undefined;
    component.displayTransactions = false;
    component.transactions = [];
    component.selectedInvoiceData = {} ;
    component.selectedInvoice = null;
    component.searchDate = null;
    component.showInvoiceDialog = false;
    component.selectedTransaction = undefined;
    component.displayDialog = false;
    component.splitBillDialog = false;
    component.splitMethod = 'item';
    component.numberOfPeople = 1;
    component.savedReceipts = [];
    component.selectedReceipt = null;
    component.savedReceiptsDialog = false;
    component.searchProductTerm.reset('');
    // Properly stop scanner and reset scanner state
    component.hasScannerClicked = false;
    if (component.action) {
        component.action.stop();
    }
    component.vatRate = 0;
    component.searchTerm = '';
    component.filteredProducts = [];
    component.products = [];
    component.productsTemp = [];
    component.selectedProductId = null;
    component.currentPSID = null;
    component.hasScannedProduct = false;
    component.userName = '';
    component.selectedPaymentOptions = ['Cash']; // Always ensure Cash is selected
    component.cashAmount = 0;
    component.refundCashAmount = 0;
    component.cardDetails = {
        name: null,
        number: 0,
        expiry: null,
        amount: null,
        transactionId: null,
    };
    component.upiDetails = {
        upiId: null,
        upiAmount: 0,
        transactionId: null,
    };
    component.redeemCreditAmount = 0;
    component.currentOrderId = '';
    component.invoice = {};
    component.hasShownCreditNumberMessage = false;
    component.showExchangeConfirmation = false;
    component.pendingExchangePayload = null; // Clear pending exchange payload

    // Reset Delete Mode
    component.isDeleteMode = false;
    component.isScannerDeleteMode = false;

    // Reset form data through the service to update header fields
    component.formDataService.updateFormData({
        mobileNumber: '',
        customerName: '',
        currentDate: new Date(),
        salesRep: '',
        isExchangeOrder: false,
        isDeleteMode: false
    });
    component.formData = null;

    setTimeout(() => {
        component.focusProductSearch();
    }, 200);

}
